import { createRouter, createWebHistory } from 'vue-router'

const routes = [
  {
    path: '/orders/:orderParams',
    name: 'orders.show',
    component: () => import(/* webpackChunkName: "orders.show" */ '@/pages/OrderPage.vue'),
    props: true,
  },
  {
    path: '/:pathMatch(.*)*',
    name: 'errors.404',
    component: () => import(/* webpackChunkName: "orders.show" */ '@/pages/errors/404.vue'),
  }
]

const router = createRouter({
  history: createWebHistory(process.env.BASE_URL),
  routes
})

export default router
